//資料DL・お問い合わせボタンの表示・非表示
$(function() {
  const fixedBtn = $('.p-home__fixed');
  $(window).on('scroll', function(){
    if($(this).scrollTop() > 500) {
      fixedBtn.addClass('scroll-active');
    }else{
      fixedBtn.removeClass('scroll-active');
    }
  });
});
